import { Pipe, PipeTransform } from "@angular/core";
import { utcToFutureRelativeTime } from 'app/shared/helpers/utils';

@Pipe({
    name: 'futureRelativeTime',
    standalone: false
})
export class FutureRelativeTimePipe implements PipeTransform {
    transform(value: string | Date): string {
        if (!value) { return ''; }
        const iso = value instanceof Date ? value.toISOString() : value;
        return utcToFutureRelativeTime(iso);
    }
}
